export function Notice() {
  return (
    <>
      <div>현재 플레이룸 구현에 최선을 다하고있습니다 시발!</div>
    </>
  );
}
